import { type VariantProps, cva } from 'class-variance-authority';
import type { ReactNode, JSX } from 'react';
import { twMerge } from 'tailwind-merge';

import type { CommonProps } from '../../types';

export interface TextProps
    extends CommonProps,
        VariantProps<typeof TextStyles> {
    children?: ReactNode;
}

export const TextStyles = cva('font-light', {
    variants: {
        size: {
            '2xl': 'text-2xl leading-8',
            xl: 'text-xl leading-6',
            lg: 'text-lg leading-6',
            md: 'text-base leading-6',
            sm: 'text-sm leading-5',
            xs: 'text-xs leading-4',
        },
    },
    defaultVariants: {
        size: 'md',
    },
});

export const Text = ({
    size,
    className,
    children,
    testId = 'text',
    ...props
}: TextProps): JSX.Element => {
    return (
        <span
            className={twMerge(TextStyles({ size, className }))}
            data-testid={testId}
            {...props}
        >
            {children}
        </span>
    );
};
